/**
 * Shown only after /api/ai/chat returns HTTP 429 (retry/RPM path). Countdown appears when Retry-After was present.
 */
export default function RateLimitBanner({ visible, secondsRemaining = 0 }) {
  if (!visible) return null;
  return (
    <div className="mr-4 rounded-xl border border-sky-500/25 bg-sky-500/[0.08] px-3 py-2.5">
      <p className="text-[10px] font-semibold uppercase tracking-wider text-sky-300/90">Rate limit (HTTP 429)</p>
      <p className="mt-1 text-sm leading-relaxed text-slate-100">
        {secondsRemaining > 0 ? (
          <>
            The server asked you to wait. Retry in about <strong className="tabular-nums">{secondsRemaining}</strong>{" "}
            seconds.
          </>
        ) : (
          <>The service returned HTTP 429. You can try again — there was no Retry-After window to count down.</>
        )}
      </p>
    </div>
  );
}
